import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './assessment-document.controller';
import directive from './assessment-document.directive';

export default angular.module('app.components.advisory.ecat.assessmentDocument', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('ecatAssessmentDocument', directive)
  .controller('AssessmentDocumentController', controller)
  .name;

console.log('app.components.advisory.ecat.assessmentDocument created');
